// 设置cookie
export function setCookie (name, value, expire) {
  var date = new Date()
  date.setSeconds(date.getSeconds() + expire)
  document.cookie = name + '=' + escape(value) + '; expires=' + date.toGMTString()
  console.log(document.cookie)
};
// 获取cookie
export function getCookie (name) {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      let end = document.cookie.indexOf(';', start)
      if (end === -1) end = document.cookie.length
      return unescape(document.cookie.substring(start, end))
    }
  }
  return ''
};
/* 删除cookie */
export function delCookie (name) {
  setCookie(name, '', -1)
};
// 获取页面高度
export let docHeight = () => {
  let clientheight = document.documentElement.clientHeight
  return clientheight
}
// 补0 函数
export function replacement (s) {
  return s < 10 ? '0' + s : s
}

export function flatten(arr){
  const result = []
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr[i].length; j++) {
      result.push(arr[i][j])
    }
  }
  return result
}

export function checkPhone(value){

	let reg = /^[1][0-9]{10}$/
	return reg.test(value)

}

export function checkNum(value){

	let reg = /^[0-9]*$/
	return reg.test(value)

}

export function checkFloat(value){

	let reg = /^[0-9]+(.[0-9]{1,2})?$/
	return reg.test(value)

}

// 截取url中的数据
export function getUrlData(){
  /**
  * tempStr 格式是http://域名/路由?key=value&key=value...
  */
  let tempStr = window.location.href
  /**
  * tempArr 是一个字符串数组 格式是["key=value", "key=value", ...]
  */
  let tempArr = tempStr.split('?')[1] ? tempStr.split('?')[1].split('&') : []
  /**
  * returnArr 是要返回出去的数据对象 格式是 { key: value, key: value, ... }
  */
  let returnArr = {}
  tempArr.forEach(element => {
  returnArr[element.split('=')[0]] = element.split('=')[1]
  })

 /*输出日志*/
  console.log(returnArr);
  return returnArr
}
export function copyObject(obj){
  return JSON.parse(JSON.stringify(obj));
}

export function lineColors(){

  return [
    '#c7322d',
    '#990000',
    '#e70077',
    '#a51d81',
    '#d5a79c',
    '#dc83b3',
    '#d59508',
    '#f7e616',
    '#d2c200',
    '#039b6b',
    '#1d7f39',
    '#ef5a54',
    '#0099ff',
    '#0f648f',
    '#048da0',
    '#029dbc',
    '#a59ab9',
    '#932bb5',
    '#683579',
    '#ff4a45',
    '#dd000d',
    '#cc0066',
    '#d25792',
    '#d27079',
    '#af1d42',
    '#d0b073',
    '#f1be01',
    '#a09464',
    '#4b9a3e',
    '#286b3e',
    '#265511',
    '#0071b7',
    '#eb5c20',
    '#ff9966',
    '#993300',
    '#cc3300',
    "#d16a2e",
    '#945f2b',
    '#dd6c56',
    '#ff6972',
    '#ff56ad',
    '#e73cba',
    '#efacbb',
    '#77bbbc',
    '#b08550',
    '#865d87',
    '#a5861c',
    '#9c8492',
    '#004389',
    '#272759'
  ];

}



// WEBPACK FOOTER //
// ./src/common/js/util.js